"use client";

import Image from "next/image";

interface ImageCard {
    image: string;
    imageAlt: string;
    bgColor: string;
}

interface ImagesRowProps {
    heading: string;
    description: string;
    cards: ImageCard[];
}

export function ImagesRow({
    heading,
    description,
    cards
}: ImagesRowProps) {
    return (
        <div className="my-2 lg:my-8 flex w-full flex-col pt-32">
            <div className="container mx-auto px-4 lg:px-8 pb-4">
                <div className="flex flex-col">
                    <div className="flex flex-col justify-start pb-8 text-center leading-[50px] lg:leading-[70px] md:leading-[60px]">
                        <h2>{heading}</h2>
                    </div>
                    <div className="text-center mb-12">
                        <p className="text-lg">{description}</p>
                    </div>
                </div>
            </div>
            <div className="w-full">
                <div className="container mx-auto px-4 lg:px-8">
                    <div className="grid grid-cols-1 gap-8 md:gap-y-16 md:gap-x-8 lg:gap-y-20 lg:gap-x-8 xl:gap-x-12 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                        {cards.map((card, index) => (
                            <div key={index} className={`${card.bgColor} rounded-3xl p-0 overflow-hidden text-white h-112 relative flex flex-col`}>
                                <div className="relative z-30 transform-gpu h-full w-full">
                                    <Image
                                        src={card.image}
                                        alt={card.imageAlt || ''}
                                        width={1400}
                                        height={700}
                                        className="w-full h-128 object-contain scale-90 mt-8"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
